import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import StatisticMarkLine from './statistic-mark-line';
import StatisticMarkLineDetail from './statistic-mark-line-detail';
import { StatisticMarkLineUpdate } from './statistic-mark-line-update';
import StatisticMarkLineDeleteDialog from './statistic-mark-line-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute
        path={`${match.url}/new`}
        component={StatisticMarkLineUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
      />
      <PrivateRoute
        path={`${match.url}/:id/edit`}
        component={StatisticMarkLineUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
      />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={StatisticMarkLineDetail} />
      <ErrorBoundaryRoute path={match.url} component={StatisticMarkLine} />
    </Switch>
    <PrivateRoute
      path={`${match.url}/:id/delete`}
      component={StatisticMarkLineDeleteDialog}
      hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
    />
  </>
);

export default Routes;
